import { render, staticRenderFns } from "./customer-portal-document-viewer.vue?vue&type=template&id=61b90f5e&scoped=true&"
import script from "./customer-portal-document-viewer.vue?vue&type=script&lang=js&"
export * from "./customer-portal-document-viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b90f5e",
  null
  
)

export default component.exports